import React from "react";
import "./benefit.css"
import { Container, Row } from "reactstrap";
import { CardCustom } from "../CardCustom/CardCustom";
function Benefit() {

  const data = [
    "Insentif jutaan rupiah secara langsung tanpa diundi.",
    "Kesempatan untuk travel ke luar negeri.",
    "Undangan khusus untuk menghadiri acara “Appreciation Night”.",
    "Dan berbagai macam hadiah/bonus menarik lainnya.",
  ];

  return (
    <section id="benefit" className="benefit position-relative">
      <Container>
        <h1 className="text-center pb-2">Benefit</h1>
        <Row xs={1} md={5} lg={5} className="justify-content-center gap-3 p-2 p-md-0 text-center">
          <div className="bg-overlay"></div>
          {data.map((item, id) => (
            <CardCustom key={id} text={item}/>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Benefit;